import React, { Component } from 'react';
import {Layout, Table} from 'antd';
import { FormattedMessage, FormattedHTMLMessage,   injectIntl } from 'react-intl';
import GuideNav from '../../components/navigation/GuideNav';
import Headline from '../../components/Headline';
import GuidePackTypeDefinition from '../../components/GuidePackTypeDefinition';

const { Content } = Layout;
const imgColumns = [{
  dataIndex: 'image'
}, {
  title: <FormattedMessage id="Guide.howToUse.createPkgRequirement.imageTable.numberTitle" defaultMessage="Number"/>,
  dataIndex: 'number',
  align: 'center',
},{
  title: <FormattedMessage id="Guide.howToUse.createPkgRequirement.imageTable.sizeTitle" defaultMessage="Size(px)"/>,
  dataIndex: 'size',
  align: 'center',
}];
const imgData = [{
  key:'1',
  image : <FormattedHTMLMessage id="Guide.howToUse.createPkgRequirement.imageTable.pkgImg" defaultMessage="<strong>Pack Image</strong>"/>,
  number : <FormattedMessage id="Guide.howToUse.createPkgRequirement.imageTable.pkgImg.number" defaultMessage="One"/>,
  size: <FormattedHTMLMessage id="Guide.howToUse.createPkgRequirement.imageTable.pkgImg.size" defaultMessage="250x250(px) PNG file with 72dpi resolution,<br/> less than 500KB"/>
},{
  key:'2',
  image : <FormattedHTMLMessage id="Guide.howToUse.createPkgRequirement.imageTable.stickerImg" defaultMessage="<strong>Sticker Image</strong>"/>,
  number : <FormattedHTMLMessage id="Guide.howToUse.createPkgRequirement.imageTable.stickerImg.number.plus" defaultMessage="At least one, no maximum<br/>number of images"/>,
  size: <FormattedHTMLMessage id="Guide.howToUse.createPkgRequirement.imageTable.stickerImg.size" defaultMessage="618x618(px) PNG file or GIF file<br/>referring to the Production Guide page <br/>with 72dpi resolution, less than 500KB"/>
}];

const textColumns = [{
  dataIndex: 'text',
}, {
  title: <FormattedMessage id="Guide.howToUse.createPkgRequirement.textTable.languageTitle" defaultMessage="Language"/>,
  dataIndex: 'language',
  align: 'center',
},{
  title: <FormattedMessage id="Guide.howToUse.createPkgRequirement.textTable.charactersTitle" defaultMessage="The number of characters"/>,
  dataIndex: 'characters',
  align: 'center',
}];
const textData = [{
  key:'1',
  text : <FormattedHTMLMessage id="Guide.howToUse.createPkgRequirement.textTable.pkgName" defaultMessage="<strong>Pack Name</strong>"/>,
  language : <FormattedMessage id="Guide.howToUse.createPkgRequirement.textTable.pkgName.language" defaultMessage="English required"/>,
  characters: <FormattedMessage id="Guide.howToUse.createPkgRequirement.textTable.pkgName.characters" defaultMessage="No maximum number of characters"/>
},{
  key:'2',
  text : <FormattedHTMLMessage id="Guide.howToUse.createPkgRequirement.textTable.pkgDescription" defaultMessage="<strong>Pack Description</strong>"/>,
  language : <FormattedMessage id="Guide.howToUse.createPkgRequirement.textTable.pkgDescription.language" defaultMessage="No Language Restrictions"/>,
  characters: <FormattedMessage id="Guide.howToUse.createPkgRequirement.textTable.pkgDescription.characters" defaultMessage="No maximum number of characters"/>
}];
class HowToUse extends Component{

  render(){
    const language = this.props.intl.locale;
    return (
      <div>
      <Layout style={{ background: '#fff' }}>
        <GuideNav selectedKey={"plusPack"} openKey={"packType"}/>
        <Content style={{margin:20}}>
          <Headline id="Guide.howToUse.headline.plusPack" defaultMessage="How to use"/>
          <div style={{margin:25}}>
            <GuidePackTypeDefinition packType={'PLUS'} />
            <p className="how-to-make-guide-pack-type">
              <FormattedMessage 
                id='Guide.howToUse.subtitle.plusPack'
                defaultMessage='How to submit a Plus Pack'
              />
            </p>
            <p className="how-to-use-sub-title" id="createPackage">
              <FormattedMessage
                id={'Guide.howToUse.subTitle.plusPack.1'}
                defaultMessage={'1. Click Upload on the menu above.'}
              />
            </p>
            
            <p className="how-to-use-sub-desc">
              <FormattedHTMLMessage
                id='Guide.howToUse.description.plusPack.1'
                defaultMessage="*Once submitted pack can't be modified so please submit it carefully."
              />
            </p>

            <img src={require('../../img/guide/how_to_use/howtouse_01.png').default} className="how-to-use-img" alt="how-to-use-img-01"/>

            <p className="how-to-use-sub-title" id="createPackage">
              <FormattedMessage
                id={'Guide.howToUse.subTitle.plusPack.2'}
                defaultMessage={'2. Please select the sticker type of your Plus Pack.'}
              />
            </p>

            <img src={require(`../../img/guide/how_to_use/howtouse_plus_02_${language}.png`).default} style={{width: '100%', margin: '20px auto 30px auto'}} alt=""/>

            <p
            className="how-to-use-sub-title" id="selectFile">
              <FormattedMessage
                id={'Guide.howToUse.subTitle.plusPack.3'}
                defaultMessage={'3. Please enter the information and language of the pack you want to submit.'}
              />
            </p>
            <img src={require(`../../img/guide/how_to_use/howtouse_plus_03_${language}.png`).default} className="how-to-use-img" alt=""/>

            <p  style={{margin:'70px 0px 24px', fontSize: 16, color: '#000'}}>
              <FormattedMessage
                id="Guide.howToUse.createPkgRequirement.title" 
                defaultMessage="⚠️Mandatory when creating a pack"
              />
            </p>

            <p style={{fontSize:14, color :'#4a4a4a'}}>
              <FormattedHTMLMessage
                id="Guide.howToUse.createPkgRequirement.title.image" 
                defaultMessage="<strong>Image</strong>"
              />
            </p>

            <Table
              columns={imgColumns}
              dataSource={imgData}
              pagination={false}
              className="how-to-use-table"
            />

            <p style={{marginTop:15,  fontSize:14, color :'#4a4a4a'}}>
              <FormattedHTMLMessage
                id="Guide.howToUse.createPkgRequirement.textTable" 
                defaultMessage="<strong>Text</strong>"
              />
            </p>


            <Table
              columns={textColumns}
              dataSource={textData}
              pagination={false}
              className="how-to-use-table"
            />

            <p className="how-to-use-sub-title" id="afterUpload">
              <FormattedMessage
                id={'Guide.howToUse.subTitle.plusPack.4'}
                defaultMessage={'4. Please upload at least 24 stickers for the pack you are submitting.'}
              />
            </p>
            <img src={require(`../../img/guide/how_to_use/howtouse_04_nav_${language}.png`).default} style={{width:'734px',marginBottom:'24px'}}  alt=""/>
            <img src={require(`../../img/guide/how_to_use/howtouse_plus_04_${language}.png`).default} className="how-to-use-img" alt=""/>
            <p className="how-to-use-sub-title" id="afterUpload">
              <FormattedMessage
                id="Guide.howToUse.subTitle.plusPack.5"
                defaultMessage="5. Please select the tag and language of the sticker you are submitting."
              />
            </p>
            <img src={require(`../../img/guide/how_to_use/howtouse_05_nav_${language}.png`).default} className="how-to-use-img" alt="" style={{marginBottom:48}}/>
            <img src={require(`../../img/guide/how_to_use/howtouse_plus_05_01_${language}.png`).default} className="how-to-use-img" alt="" style={{marginBottom:48}}/>
            <img src={require(`../../img/guide/how_to_use/howtouse_plus_05_02_${language}.png`).default} className="how-to-use-img" alt="" style={{marginBottom:80}}/>

            <p className='how-to-use-sub-title' id='afterUpload'>
              <FormattedMessage
                id='Guide.howToUse.subTitle.plusPack.6'
                defaultMessage='6. If you have selected the tag and language for all stickers, please press the Submit Review button to complete the Plus Pack submission.'
              />
            </p>
            <p className="how-to-use-sub-desc">
              <FormattedHTMLMessage
                id='Guide.howToUse.description.plusPack.6'
                defaultMessage="<span style='color: red'>*</span>Once submitted pack can't be modified so please submit it carefully."
              />
            </p>
            <img src={require(`../../img/guide/how_to_use/howtouse_plus_06_${language}.png`).default} className="how-to-use-img" alt="" style={{marginBottom:40,width:'820px',position:'relative',left:'-45px'}}/>
          </div>
        </Content>
      </Layout>
      </div>
    );
  }

}

  
HowToUse = injectIntl(HowToUse);
export default HowToUse;
